import { useQuery } from "@tanstack/react-query";

import { getTenant } from "@/lib/api/tenant";
import type { TenantInfo } from "@/types/tenant";

export const TENANT_QUERY_KEY = ["tenant"] as const;

/**
 * The workspace's own metadata — currently its tier (ADR-049).
 *
 * `staleTime: Infinity` because a tenant's placement changes only when
 * it is migrated between tenancy models, which is a provisioning
 * operation, not something that happens while someone has a tab open.
 * Re-reading it on every window focus would buy nothing.
 *
 * This is the application shell's only data dependency, and it is a
 * plain database read. It exists so the shell stops asking the billing
 * endpoint — which reaches the payment provider for any tenant that has
 * ever checked out — for a fact the provider never held.
 */
export function useTenant({ enabled = true }: { enabled?: boolean } = {}) {
  return useQuery<TenantInfo, Error>({
    queryKey: TENANT_QUERY_KEY,
    queryFn: getTenant,
    enabled,
    staleTime: Infinity,
  });
}
